<script>
  export let items;
</script>

{#each items as item (item.id)}
{ ((item.id) == items.length && (items.length > 1)) ? " and " : ""}
{#if item.url}
<a target="_blank" href="{item.url}">{item.name}</a>{ (item.id + 1) < items.length ? ", " : ""}
{:else}
{item.name}{ (item.id + 1) < items.length ? ", " : ""}
{/if}
{/each}

<style>
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
